module.exports = __webpack_public_path__ + "static/media/user.d33e4c96.svg";